<template>
  <div>
    <div class="flex flex-row justify-between p-2 bg-primary-dark">
      <h2 class="">Compare label versions</h2>
      <div v-if="assignedPrinters.length > 0" class="w-1/4 h-full">
        <div class="flex items-center justify-end">
          <g-button
            class="mt-3 mb-2 button big primary white"
            @click="printerSelectOpen = !printerSelectOpen"
            >Test print</g-button
          >
        </div>
      </div>
    </div>
    <div class="flex justify-center">
      <preview-images
        :data="this.currentComparisons"
        @openPreview="openPreview"
      />
    </div>

    <modal
      v-if="printerSelectOpen"
      @close="printerSelectOpen = !printerSelectOpen"
    >
      <template slot="header">
        <img src="../assets/images/printer.svg" alt="printer" />
      </template>
      <template slot="body">
        <div
          v-for="label in uniqueLabels"
          :key="`${label.labelId}--${componentKey}`"
          class="flex items-center px-4 mb-2 text-white rounded bg-primary-light"
        >
          <h4 class="flex-1 mr-4">{{ label.name }}</h4>
          <drop-down
            class="flex-1"
            placeholder="Select printer"
            :value="getSelectedPrinter(label.labelId)"
            value-property="name"
            search-prop="name"
            :options="assignedPrinters"
            @input="setPrinter(label, $event)"
          />
        </div>
      </template>
      <template slot="buttons">
        <div v-if="this.printerSelect[this.$route.params.labelId]">
          <g-button class="mb-2 button big primary white" @click="print"
            >Print</g-button
          >
          <g-button class="mb-2 button big primary white" @click="generatePdf"
            >Print PDF</g-button
          >
        </div>
      </template>
    </modal>

    <modal v-if="showPreview" type="success" @close="hidePreview">
      <template slot="body">
        <div
          style="max-width: 800px; max-height: 600px"
          class="relative flex justify-center p-4 bg-primary-light"
        >
          <img class="block object-contain" :src="currentPreview" alt="label" />
        </div>
      </template>
    </modal>
    <loading
      v-if="loading"
      heading="Loading"
      description="Generating preview"
    />
  </div>
</template>

<script>
import Modal from "./Modal";
import PreviewImages from "components/PreviewImages";
import Loading from "components/Loading";
import GButton from "components/forms/Button";
import DropDown from "components/forms/DropDown";
import { sendToPrinterService } from "@/utils/printerHelpers";

export default {
  props: {
    data: {
      type: Array,
      default: () => [],
    },
    printers: {
      type: Array,
      default: () => [],
    },
    presetprinter: {
      type: String,
      default: null,
    },
    labelVersionId: {
      type: Number,
      default: 0,
    },
  },
  data: () => ({
    showPreview: false,
    loading: false,
    currentPreview: "",
    file: undefined,
    printerSelectOpen: false,
    printerSelect: {},
    componentKey: 0,
    printEnabled: false,
    printPdfEnabled: false,
    hasPresetPrinter: false,
    printing: false,
  }),
  components: {
    Modal,
    PreviewImages,
    Loading,
    GButton,
    DropDown,
  },
  computed: {
    currentComparisons() {
      return this.data;
    },
    uniqueLabels() {
      return this.currentComparisons.filter((obj, pos, arr) => {
        return (
          arr.map(mapObj => mapObj["labelId"]).indexOf(obj["labelId"]) === pos
        );
      });
    },
    activeVersion() {
      return this.$store.getters["QUALITY_ASSURANCE/VERSION"];
    },
    labelVariables() {
      const variables = [
        {
          Name: "Name",
          Description: "Name",
          CurrentValue: "",
          CurrentInputValue: "",
          IncrementType: 0,
          PromptText: "Name",
          PromptOrder: 1016,
          IncrementStep: 0,
          IncrementCount: 1,
          Format: 0,
          IsUsed: true,
          Length: 50,
          IsValueRequired: false,
          IsFixedLength: false,
          IsPrompted: true,
          DefaultValue: "",
          VariableType: 1,
          IsPickListEnabled: false,
          PickListValues: null,
          MinimumValue: "",
          HasMinimumValue: false,
          MaximumValue: "",
          HasMaximumValue: false,
          HasRolloverOnMinimumMaximumValue: false,
          Prefix: "",
          Suffix: "",
          IsDynamicValue: false,
          InputFormat: null,
          OutputFormat: null,
        },
        {
          Name: "Shipment",
          Description: "Shipment",
          CurrentValue: "",
          CurrentInputValue: "",
          IncrementType: 0,
          PromptText: "Shipment",
          PromptOrder: 1013,
          IncrementStep: 0,
          IncrementCount: 1,
          Format: 0,
          IsUsed: true,
          Length: 11,
          IsValueRequired: false,
          IsFixedLength: false,
          IsPrompted: true,
          DefaultValue: "",
          VariableType: 1,
          IsPickListEnabled: false,
          PickListValues: null,
          MinimumValue: "",
          HasMinimumValue: false,
          MaximumValue: "",
          HasMaximumValue: false,
          HasRolloverOnMinimumMaximumValue: false,
          Prefix: "",
          Suffix: "",
          IsDynamicValue: false,
          InputFormat: null,
          OutputFormat: null,
        },
        {
          Name: "Ship-to",
          Description: "Ship-to",
          CurrentValue: "",
          CurrentInputValue: "",
          IncrementType: 0,
          PromptText: "Ship-to",
          PromptOrder: 1022,
          IncrementStep: 0,
          IncrementCount: 1,
          Format: 0,
          IsUsed: true,
          Length: 20,
          IsValueRequired: false,
          IsFixedLength: false,
          IsPrompted: true,
          DefaultValue: "",
          VariableType: 1,
          IsPickListEnabled: false,
          PickListValues: null,
          MinimumValue: "",
          HasMinimumValue: false,
          MaximumValue: "",
          HasMaximumValue: false,
          HasRolloverOnMinimumMaximumValue: false,
          Prefix: "",
          Suffix: "",
          IsDynamicValue: false,
          InputFormat: null,
          OutputFormat: null,
        },
        {
          Name: "Street",
          Description: "Street",
          CurrentValue: "",
          CurrentInputValue: "",
          IncrementType: 0,
          PromptText: "Street",
          PromptOrder: 1017,
          IncrementStep: 0,
          IncrementCount: 1,
          Format: 0,
          IsUsed: true,
          Length: 50,
          IsValueRequired: false,
          IsFixedLength: false,
          IsPrompted: true,
          DefaultValue: "",
          VariableType: 1,
          IsPickListEnabled: false,
          PickListValues: null,
          MinimumValue: "",
          HasMinimumValue: false,
          MaximumValue: "",
          HasMaximumValue: false,
          HasRolloverOnMinimumMaximumValue: false,
          Prefix: "",
          Suffix: " ",
          IsDynamicValue: false,
          InputFormat: null,
          OutputFormat: null,
        },
        {
          Name: "Postl Code",
          Description: "Postl Code",
          CurrentValue: "",
          CurrentInputValue: "",
          IncrementType: 0,
          PromptText: "Postl Code",
          PromptOrder: 1019,
          IncrementStep: 0,
          IncrementCount: 1,
          Format: 0,
          IsUsed: true,
          Length: 6,
          IsValueRequired: false,
          IsFixedLength: false,
          IsPrompted: true,
          DefaultValue: "",
          VariableType: 1,
          IsPickListEnabled: false,
          PickListValues: null,
          MinimumValue: "",
          HasMinimumValue: false,
          MaximumValue: "",
          HasMaximumValue: false,
          HasRolloverOnMinimumMaximumValue: false,
          Prefix: "",
          Suffix: "  ",
          IsDynamicValue: false,
          InputFormat: null,
          OutputFormat: null,
        },
        {
          Name: "DlvTy",
          Description: "DlvTy",
          CurrentValue: "",
          CurrentInputValue: "",
          IncrementType: 0,
          PromptText: "DlvTy",
          PromptOrder: 1015,
          IncrementStep: 0,
          IncrementCount: 1,
          Format: 0,
          IsUsed: true,
          Length: 15,
          IsValueRequired: false,
          IsFixedLength: false,
          IsPrompted: true,
          DefaultValue: "",
          VariableType: 1,
          IsPickListEnabled: false,
          PickListValues: null,
          MinimumValue: "",
          HasMinimumValue: false,
          MaximumValue: "",
          HasMaximumValue: false,
          HasRolloverOnMinimumMaximumValue: false,
          Prefix: "",
          Suffix: "",
          IsDynamicValue: false,
          InputFormat: null,
          OutputFormat: null,
        },
        {
          Name: "Delivery",
          Description: "Delivery",
          CurrentValue: "",
          CurrentInputValue: "",
          IncrementType: 0,
          PromptText: "Delivery",
          PromptOrder: 1014,
          IncrementStep: 0,
          IncrementCount: 1,
          Format: 0,
          IsUsed: true,
          Length: 10,
          IsValueRequired: false,
          IsFixedLength: false,
          IsPrompted: true,
          DefaultValue: "",
          VariableType: 1,
          IsPickListEnabled: false,
          PickListValues: null,
          MinimumValue: "",
          HasMinimumValue: false,
          MaximumValue: "",
          HasMaximumValue: false,
          HasRolloverOnMinimumMaximumValue: false,
          Prefix: "",
          Suffix: "",
          IsDynamicValue: false,
          InputFormat: null,
          OutputFormat: null,
        },
        {
          Name: "City",
          Description: "City",
          CurrentValue: "",
          CurrentInputValue: "",
          IncrementType: 0,
          PromptText: "City",
          PromptOrder: 1020,
          IncrementStep: 0,
          IncrementCount: 1,
          Format: 0,
          IsUsed: true,
          Length: 35,
          IsValueRequired: false,
          IsFixedLength: false,
          IsPrompted: true,
          DefaultValue: "",
          VariableType: 1,
          IsPickListEnabled: false,
          PickListValues: null,
          MinimumValue: "",
          HasMinimumValue: false,
          MaximumValue: "",
          HasMaximumValue: false,
          HasRolloverOnMinimumMaximumValue: false,
          Prefix: "",
          Suffix: " ",
          IsDynamicValue: false,
          InputFormat: null,
          OutputFormat: null,
        },
        {
          Name: "House-Street.No",
          Description: "House-Street.No",
          CurrentValue: "",
          CurrentInputValue: "",
          IncrementType: 0,
          PromptText: "House/Street.No",
          PromptOrder: 1018,
          IncrementStep: 0,
          IncrementCount: 1,
          Format: 0,
          IsUsed: true,
          Length: 6,
          IsValueRequired: false,
          IsFixedLength: false,
          IsPrompted: true,
          DefaultValue: "",
          VariableType: 1,
          IsPickListEnabled: false,
          PickListValues: null,
          MinimumValue: "",
          HasMinimumValue: false,
          MaximumValue: "",
          HasMaximumValue: false,
          HasRolloverOnMinimumMaximumValue: false,
          Prefix: "",
          Suffix: " \r",
          IsDynamicValue: false,
          InputFormat: null,
          OutputFormat: null,
        },
        {
          Name: "Location",
          Description: "Location",
          CurrentValue: "",
          CurrentInputValue: "",
          IncrementType: 0,
          PromptText: "Location",
          PromptOrder: 1012,
          IncrementStep: 0,
          IncrementCount: 1,
          Format: 0,
          IsUsed: true,
          Length: 5,
          IsValueRequired: false,
          IsFixedLength: false,
          IsPrompted: true,
          DefaultValue: "",
          VariableType: 1,
          IsPickListEnabled: false,
          PickListValues: null,
          MinimumValue: "",
          HasMinimumValue: false,
          MaximumValue: "",
          HasMaximumValue: false,
          HasRolloverOnMinimumMaximumValue: false,
          Prefix: "",
          Suffix: "",
          IsDynamicValue: false,
          InputFormat: null,
          OutputFormat: null,
        },
      ];
      return this.activeVersion.variables
        ? this.activeVersion.variables.map(lv => ({
            ...lv,
            key: lv.Description,
            name: `${lv.Description} (Max ${lv.Length} Chars)`,
            data: "123456789123".substring(0, lv.Length - 1),
          }))
        : variables.map(lv => ({
            ...lv,
            key: lv.Description,
            name: `${lv.Description} (Max ${lv.Length} Chars)`,
            data: "123456789123".substring(0, lv.Length - 1),
          }));
    },
    assignedGroupLabels() {
      return this.$store.getters["LABELS/ASSIGNED_LABELS"];
    },
    assignedPrinters() {
      let assignedPrinters = this.assignedGroupLabels
        .flatMap(x => x.labels)
        .flatMap(x => x.printers)
        .flatMap(x => x.printerId);
      return this.printers.filter(p => {
        return assignedPrinters.find(x => x === p.id);
      });
    },
  },
  methods: {
    async getData() {
      const data = {
        labelId: this.$route.params.labelId,
        versionId:
          this.labelVersionId != 0
            ? this.labelVersionId
            : this.$route.params.versionId,
      };
      await this.$store.dispatch("QUALITY_ASSURANCE/GET_VERSION", data);
      let assignedGroupLabels = this.$store.getters["LABELS/ASSIGNED_LABELS"];
      if (assignedGroupLabels.length === 0) {
        await this.$store.dispatch("LABELS/GET_ASSIGNED_LABELS");
        assignedGroupLabels = this.$store.getters["LABELS/ASSIGNED_LABELS"];
      }
    },
    getUniqueLabels() {
      this.uniqueLabels.forEach(label => {
        if (this.presetprinter) {
          const presetPrinter = this.assignedPrinters.find(
            p => p.id === this.presetprinter
          );
          if (presetPrinter) {
            this.printerSelect[label.labelId] = presetPrinter;
            this.hasPresetPrinter = true;
            return;
          }
        }

        if (this.assignedGroupLabels) {
          let defaultPrinters = this.assignedGroupLabels
            .flatMap(x => x.labels)
            .filter(l => l.labelId === label.labelId)
            .flatMap(x => x.printers)
            .filter(p => p.isDefault);
          const printer =
            defaultPrinters &&
            defaultPrinters.length &&
            this.assignedPrinters.find(
              printer => printer.id === defaultPrinters[0].printerId
            );
          if (printer) {
            this.printerSelect[label.labelId] = printer;
            this.hasPresetPrinter = true;
            return;
          }
        }

        if (label.defaultPrinter) {
          const printer = this.printers.find(
            printer => printer.id === label.defaultPrinter
          );
          if (printer) {
            this.printerSelect[label.labelId] = printer;
            this.hasPresetPrinter = true;
          }
        } else if (label.groups[0] && label.groups[0].defaultPrinterId) {
          const printer = this.printers.find(
            printer => printer.id === label.groups[0].defaultPrinterId
          );
          if (printer) {
            this.printerSelect[label.labelId] = printer;
            this.hasPresetPrinter = true;
          }
        }
      });
    },
    getSelectedPrinter(labelId) {
      return this.printerSelect[labelId] ? this.printerSelect[labelId] : {};
    },
    setPrinter(label, printer) {
      this.printerSelect[label.labelId] = printer;
      this.componentKey++;
      this.printEnabled = true;
      this.printPdfEnabled = true;
    },
    openPreview(data) {
      this.currentPreview = data;
      this.showPreview = true;
    },
    hidePreview() {
      this.showPreview = false;
      this.currentPreview = "";
    },
    async generatePdf() {
      try {
        const payload = {
          labelId: parseInt(this.currentComparisons[0].labelId),
          quantity: 1,
          labelVariables: this.labelVariables,
          versionId: parseInt(this.currentComparisons[0].versionId),
          printerId: parseInt(
            this.printerSelect[this.currentComparisons[0].labelId].id
          ),
        };

        this.printing = true;
        const response = await this.$store.$api.post(
          "/api/printjobs/dummy/pdf",
          payload,
          {
            responseType: "blob",
            headers: {
              "Content-Disposition":
                'attachment; filename="label.pdf"; filename*="label.pdf"',
            },
          }
        );
        this.printing = false;
        this.openPdf(response.data);
      } catch (error) {
        throw error;
      }
    },
    openPdf(file) {
      const fileUrl = window.URL.createObjectURL(new Blob([file]));
      const fileLink = document.createElement("a");
      const fileName = this.uniqueLabels[0].name;
      fileLink.target = "_blank";
      fileLink.href = fileUrl;
      fileLink.setAttribute("download", `${fileName}.pdf`);
      document.body.appendChild(fileLink);
      fileLink.click();
    },
    async print() {
      try {
        this.printing = true;
        let printFile = {};
        const printerHelperUri = this.$store.getters[
          "SETTINGS/PRINTER_HELPER_URI"
        ];

        const payload = {
          labelId: parseInt(this.currentComparisons[0].labelId),
          quantity: 1,
          labelVariables: this.labelVariables,
          versionId: parseInt(this.currentComparisons[0].versionId),
          printerId: parseInt(
            this.printerSelect[this.currentComparisons[0].labelId].id
          ),
        };

        const response = await this.$store.$api.post(
          "/api/printjobs/dummy",
          payload
        );
        printFile = response.data.data;
        await sendToPrinterService(printerHelperUri, {
          targetAddress: printFile.targetIpAddress,
          port: printFile.targetPort,
          targetPrintQueue: printFile.targetPrintQueue,
          printerFileUrl: printFile.printFileName,
          useLocalPrinterDriver: printFile.useLocalPrinterDriver,
          pdfAsBase64String: printFile.pdfAsBase64String,
          orientation: printFile.orientation,
          scale: printFile.scale,
          side: printFile.side,
          paperSize: printFile.paperSize,
          customPaperSize: printFile.customPaperSize,
        });
      } catch (error) {
        throw error;
      } finally {
        this.printing = false;
      }
    },
  },
  async mounted() {
    await this.getData();
    this.uniqueLabels.forEach(label => {
      if (this.presetprinter) {
        const presetPrinter = this.assignedPrinters.find(
          p => p.id === this.presetprinter
        );
        if (presetPrinter) {
          this.printerSelect[label.labelId] = presetPrinter;
          this.hasPresetPrinter = true;
          return;
        }
      }

      if (this.assignedGroupLabels) {
        let defaultPrinters = this.assignedGroupLabels
          .flatMap(x => x.labels)
          .filter(l => l.labelId === label.labelId)
          .flatMap(x => x.printers)
          .filter(p => p.isDefault);
        const printer =
          defaultPrinters &&
          defaultPrinters.length &&
          this.assignedPrinters.find(
            printer => printer.id === defaultPrinters[0].printerId
          );
        if (printer) {
          this.printerSelect[label.labelId] = printer;
          this.hasPresetPrinter = true;
          return;
        }
      }

      if (label.defaultPrinter) {
        const printer = this.printers.find(
          printer => printer.id === label.defaultPrinter
        );
        if (printer) {
          this.printerSelect[label.labelId] = printer;
          this.hasPresetPrinter = true;
        }
      } else if (label.groups[0] && label.groups[0].defaultPrinterId) {
        const printer = this.printers.find(
          printer => printer.id === label.groups[0].defaultPrinterId
        );
        if (printer) {
          this.printerSelect[label.labelId] = printer;
          this.hasPresetPrinter = true;
        }
      }
    });

    this.componentKey++;
  },
};
</script>
